import styled from 'styled-components';
import { colors, typography } from '@99designs/emu/settings';

const SidebarSubtleText = styled.small`
    color: ${colors.grey700};
    font-size: ${typography.typeScale.size2}px;
`;

export default SidebarSubtleText;
